// eslint-disable-next-line import/no-webpack-loader-syntax
module.exports = require('./lib/bootstrap.loader!./no-op.js');



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-loader/loader.js
// module id = 216
// module chunks = 0